import Request from './authorized-request';

export default class InspectionsApi {
  static async fetch(options) {
    return Request.get('/maintenance_log', {
      params: {
        ...options,
      },
    });
  }

  static async export() {
    return Request.post('/maintenance_log/export', null, { responseType: 'blob' });
  }
}
